import { render } from "./Family.vue?vue&type=template&id=01cd6260&scoped=true"
import script from "./Family.vue?vue&type=script&lang=js"
export * from "./Family.vue?vue&type=script&lang=js"

import "./Family.vue?vue&type=style&index=0&id=01cd6260&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cd6260"]])

export default __exports__